import { Box, Button, Card, Grid, TextField } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";

import { useFormik } from "formik";
import { useState } from "react";
import { exportToExcel } from "react-json-to-excel";
import Service from "services/purchases";
import { DataGrid } from "@mui/x-data-grid";
import { ptBR_DataGrid } from "utils/datagrid";

const initialValues = {
  startDate: "",
  endDate: "",
};

export default function TotalProdutosVendidos() {
  const [loading, setLoading] = useState(false);
  const [report, setReport] = useState([]);

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: async (values) => {
      setLoading(true);

      try {
        const data = await Service.productReport({
          ...values,
        });

        const products = parseProducts(data);

        if (!products.length) {
          alert("Nenhum resultado encontrado");
        }

        setReport(products);

        setLoading(false);
      } catch (error) {
        alert("Nenhum resultado encontrado");
        console.log(error);
      }

      setLoading(false);
    },
  });

  const parseProducts = (rows) => {
    const products = rows.map((row) => {
      return {
        "Código Interno": row.product?.codigoInterno || "",
        Descrição: row.product?.descricao || "",
        "Unidade de Medida": row.measure || "",
        "Quantidade Total": row.totalQuantity || "",
      };
    });

    return products;
  };

  const printProducts = (products) => {
    exportToExcel(products, "produtos_comprados_" + new Date().getTime(), true);
  };

  return (
    <DashboardLayout>
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <MDTypography variant="h6" color="white" mt={1}>
                  Relatório do Total de Produtos Comprados
                </MDTypography>
              </MDBox>
              <MDBox pt={3} mx={2} py={3} px={2}>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(2, 1fr)",
                    gap: 2,
                    mb: 2,
                  }}
                  component="form"
                  onSubmit={formik.handleSubmit}
                >
                  <TextField
                    id="startDate"
                    name="startDate"
                    label="Data Inicial"
                    type="date"
                    value={formik.values.startDate}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={loading}
                    error={
                      formik.touched.startDate &&
                      Boolean(formik.errors.startDate)
                    }
                    helperText={
                      formik.touched.startDate && formik.errors.startDate
                    }
                    sx={{
                      width: "100%",
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />

                  <TextField
                    id="endDate"
                    name="endDate"
                    label="Data Final"
                    type="date"
                    value={formik.values.endDate}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={loading}
                    error={
                      formik.touched.endDate && Boolean(formik.errors.endDate)
                    }
                    helperText={formik.touched.endDate && formik.errors.endDate}
                    sx={{
                      width: "100%",
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />

                  <Button
                    type="submit"
                    variant="contained"
                    disabled={loading}
                    sx={{
                      gridColumn: "span 2",
                      justifySelf: "center",
                      width: "100%",
                      color: "white !important",
                    }}
                  >
                    {loading ? "Carregando..." : "Gerar Relatório"}
                  </Button>
                </Box>
              </MDBox>
            </Card>

            {report.length > 0 && (
              <>
                <Card sx={{ marginTop: 4 }}>
                  <DataGrid
                    initialState={{
                      pagination: { paginationModel: { pageSize: 25 } },
                    }}
                    pageSizeOptions={[25, 100]}
                    rows={report.map((row, index) =>
                      Object({ ...row, id: index })
                    )}
                    columns={Object.keys(report[0]).map((key) =>
                      Object({
                        headerName: key,
                        field: key,
                        flex: Object.keys(report[0]).length / 10,
                      })
                    )}
                    rowCount={report.length}
                    rowSelection={false}
                    localeText={ptBR_DataGrid}
                    sx={{
                      ".MuiDataGrid-virtualScroller": {
                        minHeight: "100px",
                      },
                    }}
                  />
                </Card>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    p: 2,
                  }}
                >
                  <Button
                    variant="contained"
                    onClick={() =>
                      printProducts([
                        {
                          sheetName: "Total de Produtos Comprados",
                          details: report,
                        },
                      ])
                    }
                    sx={{
                      color: "white !important",
                    }}
                  >
                    Exportar para Excel
                  </Button>
                </Box>
              </>
            )}
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}
